import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/modals/deleteModal";
import DeletedPopUp from "../../../components/popups/DeletedPopUp";
import { deleteFieldForceDesignation } from "../../../redux/actions/fieldForceAction";
import "../../products/product.css";
import ErrorPopup from "../../../components/popups/ErrorPopup";

const DesignationTableData = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, index, currentPage } = props;
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const delFunc = () => {
    dispatch(deleteFieldForceDesignation(data.id, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      props?.fetchFieldForceDesignationList();
    };

    setTimeout(timeOutFnc, 2000);

    setDeleteShow(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1 text-nowrap">
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data.designation_id}</td>
      <td className="table-each-row-data">{data.name}</td>
      <td className="table-each-row-data">
        {data.approval_authority ? ` ₹. ${data.order_approval_upto}` : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data.approval_level}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/field-force/designation/view/${data.id}`)}
          >
            {"view"}
          </button>
          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() =>
                  navigate(`/field-force/designation/edit/${data.id}`)
                }
              >
                {"edit"}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <DeleteModal
        title={`Field Force Designation - ${data?.designation_id} ?`}
        delFunc={delFunc}
        show={deleteShow}
        handleClose={() => setDeleteShow(false)}
      />
      <DeletedPopUp
        title={`Field Force Designation - ${data?.designation_id}`}
        show={deletedPop}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </tr>
  );
};

export default DesignationTableData;
